/*
 * store.js
 */

import { applyMiddleware, compose, createStore } from "redux";
import mainReducer from "./reducers";
import thunk from "redux-thunk"; // aka this is your rootReducer

const configureStore = () => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  let store = createStore(mainReducer, composeEnhancers(applyMiddleware(thunk)));
  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept("./reducers", () => {
        store.replaceReducer(mainReducer);
      });
    }
  }

  return store;
};

export default configureStore;
